// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"12":"profiler","777":"recorder"}[chunkId] + "." + {"12":"80069a3f","777":"873da83c"}[chunkId] + ".chunk.js";
};